import request from '@/utils/request'

// 查询团队成员列表
export function queryMemberList(query) {
  return request({
    url: '/groupMember/queryList',
    method: 'get',
    params: query
  })
}

// 添加团队成员
export function addMember(data) {
  return request({
    url: '/groupMember/add',
    method: 'post',
    data: data
  })
}

// 移除团队成员
export function removeMember(data) {
  return request({
    url: '/groupMember/remove',
    method: 'put',
    data: data
  })
}

// 分页查询合同列表
export function pageContract(data) {
  return request({
    url: '/crmContract/queryList',
    method: 'post',
    data: data
  })
}

// 分页查询合同列表
export function getContractList(data) {
  return request({
    url: '/crmContract/queryList',
    method: 'post',
    data: data
  })
}

// 查询回款计划看列表
export function queryFundManageList(data) {
  return request({
    url: '/crmContract/queryFundManageList',
    method: 'post',
    data: data
  })
}


// 详情页查询合同列表
export function listContract(query) {
  return request({
    url: '/crmContract/queryListByCustomerOrBusinessId',
    method: 'get',
    params: query
  })
}

//交付单查询已签约合同
export function querySimpleList(query) {
  return request({
    url: '/crmContract/querySimpleList',
    method: 'post',
    data: query
  })
}

// 校验合同名称
export function checkContractName(query) {
  return request({
    url: '/crmContract/checkContractName',
    method: 'get',
    params: query
  })
}

// 查询合同详情
export function queryContractDetail(query) {
  return request({
    url: '/crmContract/queryDetail',
    method: 'get',
    params: query
  })
}

// 查询合同项目财务一览
export function queryContractFinanceOverview(query) {
  return request({
    url: '/crmContractFinance/overview',
    method: 'get',
    params: query
  })
}

// 新增合同
export function createContract(data) {
  return request({
    url: '/crmContract/create',
    method: 'post',
    data: data
  })
}

// 更新合同
export function updateContract(data) {
  return request({
    url: '/crmContract/update',
    method: 'put',
    data: data
  })
}

// 查询产品型号列表
export function queryProductModelList(data) {
  return request({
    url: '/crmProduct/queryProductModelList',
    method: 'post',
    data: data
  })
}

// 查询产品类型列表,label 和 value 都是中文
export function queryProductTypeList(data) {
  return request({
    url: '/crmProduct/queryProductTypeList',
    method: 'post',
    data: data
  })
}

// 查询产品类型列表 value为id
export function queryProductTypeList2(data) {
  return request({
    url: '/crmProduct/queryProductTypeList2',
    method: 'post',
    data: data
  })
}

// 审批单详情
export function queryWorkOrder(data) {
  return request({
    url: '/workOrder/queryWorkOrder',
    method: 'post',
    data: data
  })
}

// 审批
export function handleWorkOrder(data) {
  return request({
    url: '/workOrder/handleWorkOrder',
    method: 'post',
    data: data
  })
}

// 将当前审批节点转交给其他人
export function transferWorkOrder(data) {
  return request({
    url: '/workOrder/transfer',
    method: 'post',
    data: data
  })
}

// 评论审批
export function addComment(data) {
  return request({
    url: '/workOrder/addComment',
    method: 'post',
    data: data
  })
}

// 发起合同审批
export function createApproval(data) {
  return request({
    url: '/crmContract/createApproval',
    method: 'post',
    data: data
  })
}

// 修改合同状态
export function changeStatus(data) {
  return request({
    url: '/crmContract/changeStatus',
    method: 'put',
    data: data
  })
}

// 维护合同档案号
export function updateArchiveNo(data) {
  return request({
    url: '/crmContract/archiveNo',
    method: 'put',
    data
  })
}

// 重新识别合同存档方式
export function retryArchiveRecognition(data) {
  return request({
    url: '/crmContract/archiveRecognition/retry',
    method: 'post',
    data
  })
}

// 查询项目成本列表
export function queryCostList(data) {
  return request({
    url: '/crmCost/list',
    method: 'post',
    data: data
  })
}

// 查询项目成本
export function queryCost(id) {
  return request({
    url: `/crmCost/${id}`,
    method: 'get'
  })
}

// 新增项目成本
export function addCost(data) {
  return request({
    url: '/crmCost/add',
    method: 'post',
    data: data
  })
}

// 修改项目成本
export function updateCost(data) {
  return request({
    url: '/crmCost/update',
    method: 'post',
    data: data
  })
}

// 修改项目成本
export function removeCost(id) {
  return request({
    url: `/crmCost/remove/${id}`,
    method: 'post'
  })
}

// 修改项目交付备注
export function updatePhaseRemark(data) {
  return request({
    url: '/crmContract/updatePhaseRemark',
    method: 'post',
    data: data
  })
}

// 查询项目计划
export function queryContractPhaseList(contractId) {
  return request({
    url: `/crmContractPhase/list/${contractId}`,
    method: 'get'
  })
}

// 保存项目计划
export function saveContractPhase(data) {
  if(data.id) {
    return request({
      url: '/crmContractPhase/update',
      method: 'post',
      data: data
    })
  } else {
    return request({
      url: '/crmContractPhase/save',
      method: 'post',
      data: data
    })
  }
}

// 删除项目计划
export function deleteContractPhase(id) {
  return request({
    url: `/crmContractPhase/delete/${id}`,
    method: 'post'
  })
}

// 查询施工内容
export function queryConstructionList(data) {
  return request({
      url: '/crmConstruction/list',
      method: 'post',
      data: data
    })
}

// 保存施工内容
export function saveConstruction(data) {
  if(data.id) {
    return request({
      url: '/crmConstruction/update',
      method: 'post',
      data: data
    })
  } else {
    return request({
      url: '/crmConstruction/add',
      method: 'post',
      data: data
    })
  }
}

// 删除施工内容
export function deleteConstruction(id) {
  return request({
      url: `/crmConstruction/delete/${id}`,
      method: 'post'
    })
}
